var _style, _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCsuNorthridgelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.7 40.4",
    style: {
      enableBackground: "new 0 0 115.7 40.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000085238265880052932670000014682571997847759789_);}\n\t.st1{fill:#D22030;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 250.1,
    height: 40.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030450193897207484330000013479880062847098039_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030450193897207484330000013479880062847098039_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.1,5.9v1.6c-3.9,0.6-4.2,2-4.2,6.1v21.9H108L90.5,12.3l-0.2,0V27c0,4.1,0.5,5.6,4.7,6.1v1.6H83.7v-1.6 c3.9-0.6,4.5-2,4.5-6.1V11.5c0-2.1-1.6-3.9-4.2-3.9c-2.6,0-4.2,1.8-4.2,3.9v14c0,5.6-3.8,9.9-11.2,9.9s-11.8-3.3-11.8-9.7v-1.1 v-8.1v-5c0-2.1-1.6-3.9-4.2-3.9s-4.2,1.8-4.2,3.9v0.8h-1.8c-1.4-4.1-4.1-5.2-7.3-5.2c-2.7,0-4.6,1.8-4.6,4.6c0,3,2.2,3.9,7,5.5 c4,1.3,8.3,3,8.3,8.5c0,4.9-2.9,9.8-10.3,9.8c-2.4,0-5.1-0.5-6.8-1.3l-1.5,1.3h-1.9v-9.1h2.1c2.2,5,4.9,7.2,8.6,7.2 c3.8,0,5.4-2.6,5.4-4.9c0-3-1.9-4.2-7-5.8c-4.4-1.4-8.8-3.1-8.8-8.5c0-5.5,3.8-9.6,9.5-9.6c1,0,2,0.1,3,0.2 c0.9,0.2,2,0.6,2.9,0.7c0.9,0.1,2.8,0.1,3.7,0.1c1.6,0,2.1,0,3.7,0c2.1,0,4.3,0,6.4,0c1.8,0,3.6,0,5.4,0c0.7,0,1.5,0,2.3,0v1.7 c-3,0.1-3.8,0.4-3.8,1.9v16.1c0,5.1,2.9,7.3,7.6,7.3c2.2,0,3.8-0.7,5-1.9c1.4-1.5,2.1-3.1,2.1-6.4V13.6c0-4.1-0.9-5.6-5.1-6.1 V5.9h11.2h9.2l15.6,20.5h0.2V13.6c0-4.1-0.9-5.6-5.1-6.1V5.9H115.1z M16.7,32.8c-4.6,0-9.4-4.2-9.4-12.9c0-8.5,4-12.9,8.5-12.9 c3.8,0,6.7,3.2,8.5,8.6h2V5h-1.8l-1.3,1.9c-1.8-1-4.6-1.9-7.3-1.9C7.2,5,0.5,11.6,0.5,20.5c0,8.7,5.3,15,14.5,15 c6.3,0,10.2-3.5,12.3-8.3l-1.7-0.8C23.6,30.6,20.8,32.8,16.7,32.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsuNorthridgelogo);
export default __webpack_public_path__ + "static/media/CSUNorthridgelogo.65bff3b1a1bc8e3bb328938d075cbe19.svg";
export { ForwardRef as ReactComponent };